<template lang="pug">
	.range
		.range-label(:style="styles.primary.color")
			span {{data.Label}}
			span {{format(number)}}
			span.help {{data.SubLabel}}
		.range-input
			label(
				:for="data.ID", 
				:aria-label="`${data.Label}${format(number)}`",
				aria-hidden="true", 
				tabindex="-1") {{`${data.Label}${format(number)}`}}
			input(
				:id="data.ID",
				type="range", 
				v-model="number",
				@keyup="jump($event, data.Values.Max, data.Values.Min)",
				:max="data.Values.Max",
				:min="data.Values.Min",
				step="1")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Theme from '@/listing-app/mixins/Theme'

export default {
	name: "Range",
	mixins: [Theme],
  props: ["data"],
	computed: {
		...mapGetters(["read"]),
		number: {
			get() {
				return this.read("filters")[this.data.ID].value
			},
			set(val) {
				let filter = this.data.ID
				let value = val

				this.set({muta: 'filters', data: { filter, value }})
			}
		}
	},
	methods: {
		...mapActions(["set"]),
		init() {
			if (!this.read("filters").hasOwnProperty(this.data.ID)) {
				let filter = this.data.ID
				let value = this.data.Values.Max

				this.set({muta: 'filters', data: { filter, value }})
			}
		},
		jump(e, max, min) {
			if ((e.code == "ArrowRight" || e.code == "ArrowLeft")&& e.shiftKey) {
				e.preventDefault()
				let number
				if (e.code == "ArrowRight" && e.shiftKey) {
					number = parseInt(this.number) + 99
				}
				else if (e.code == "ArrowLeft" && e.shiftKey) {
					number = parseInt(this.number) - 99
				}

				number = number > max ? max : number
				number = number < min ? min : number
				this.number = number
			}
		},
		format(val) {
			val = parseInt(val).toLocaleString()
			return val
		}
	},
	created() {
		this.init()
	}
}
</script>

<style lang="scss" scoped>
.range {
  display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
  & > * {
    width: 100%;
  }
}

.range-label {
	font-family: $fontFamilyHeadings;
	font-size: 19px;
  text-transform: uppercase;
	span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.help {
		font-size: 11px;
    display: block;
		line-height: 1;
		margin-top: -3px;
	}
}

.range-input {
  display: flex;
	align-items: center;
	padding-top: 5px;
	@media (min-width: 991px) {
		padding-top: 0;
		height: 35px;
	}
	label {
		height: 0;
		width: 0;
		font-size: 0;
		padding: 0;
		margin: 0;
		display: inline-block;
		overflow: hidden;
		opacity: 0;
		border: 0;
		outline: none;
	}
}


input[type=range] {
  -webkit-appearance: none;
  width: 100%;
  background: transparent;
}
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;
  background: transparent; 
  border-color: transparent;
  color: transparent;
}

input[type=range]::-webkit-slider-thumb {
	background: $gray;
	height: 20px;
	width: 20px;
	cursor: pointer;
	margin-top: -10px;
}
input[type=range]::-moz-range-thumb {
	background: $gray;
	height: 20px;
	width: 20px;
	cursor: pointer;
}
input[type=range]::-ms-thumb {
	background: $gray;
	height: 20px;
	width: 20px;
	cursor: pointer;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
	background: $black;
	box-sizing: content-box;
	background-clip: content-box;
	padding: 10px 0;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  background: $black;
	box-sizing: content-box;
	background-clip: content-box;
	padding: 10px 0;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  background: $black;
	box-sizing: content-box;
	background-clip: content-box;
	padding: 10px 0;
}

</style>

